(function() {
  'use strict';

  const container = document.querySelector('.koektrommel-builder');
  const SID = container.getAttribute('section-id');

  // ── Stuks configuration (thresholds for auto-switching)
  // Each entry: { stuks, min, max, price, variantId, productId }
  const STUKS_CONFIG = [];

  document.querySelectorAll(`#koektrommel-${SID} .kb-stuks-btn`).forEach(btn => {
    STUKS_CONFIG.push({
      el: btn,
      stuks:         parseInt(btn.dataset.stuks, 10),
      min:           parseInt(btn.dataset.min,   10),
      max:           parseInt(btn.dataset.max,   10),
      price:         btn.dataset.price,
      variantId:     btn.dataset.variantId || null,
      productId:     btn.dataset.productId || null,
      productHandle: btn.dataset.productHandle || null,
    });
  });

  // ── State
  let activeStuks      = STUKS_CONFIG[0] || { stuks: 5, min: 1, max: 9 };
  let totalQty         = 0;
  let drawerOpen       = false;

  // ── DOM refs
  const section        = document.getElementById(`koektrommel-${SID}`);
  const priceEl        = section.querySelector(`#kb-price-${SID}`);
  const progressFill   = section.querySelector(`#kb-progress-${SID}`);
  const totalEl        = section.querySelector(`#kb-total-${SID}`);
  const maxEl          = section.querySelector(`#kb-max-${SID}`);
  const ctaBtn         = section.querySelector(`#kb-add-to-cart-${SID}`);
  const ctaHint        = section.querySelector(`#kb-cta-hint-${SID}`);
  const drawer= document.getElementById(`kb-drawer-${SID}`);
  const drawerBody     = document.getElementById(`kb-drawer-body-${SID}`);
  const drawerTotal    = document.getElementById(`kb-drawer-total-${SID}`);
  const drawerClose    = document.getElementById(`kb-drawer-close-${SID}`);
  const drawerBackdrop = document.getElementById(`kb-drawer-backdrop-${SID}`);
  const flavourRows    = section.querySelectorAll('.kb-flavour-row');

  // Character counter for message textarea
  const textarea = section.querySelector(`#kb-bericht-${SID}`);
  const charCount = section.querySelector(`#kb-bericht-count-${SID}`);
  if (textarea && charCount) {
    textarea.addEventListener('input', () => {
      const max = parseInt(textarea.maxLength, 10);
      const len = textarea.value.length;
      charCount.textContent = `${len} / ${max} tekens`;
    });
  }
  if (textarea) textarea.disabled = true;

  // Character counter for instructions textarea
  const instructiesInput = section.querySelector(`#kb-instructies-input-${SID}`);
  const instructiesCount = section.querySelector(`#kb-instructies-count-${SID}`);
  if (instructiesInput && instructiesCount) {
    instructiesInput.addEventListener('input', () => {
      const max = parseInt(instructiesInput.maxLength, 10);
      const len = instructiesInput.value.length;
      instructiesCount.textContent = `${len} / ${max} tekens`;
    });
  }

  // ── Helpers
  function getStuksForQty(qty) {
    // Find the smallest tier whose capacity can hold this qty
    for (const s of STUKS_CONFIG) {
      if (qty <= s.stuks) return s;
    }
    // qty exceeds all tiers — return the largest (absolute max)
    return STUKS_CONFIG[STUKS_CONFIG.length - 1];
  }

  function getStuksMax() {
    return activeStuks.stuks || 5;
  }

  function updateProgress() {
    const max = getStuksMax();
    const pct = Math.min((totalQty / max) * 100, 100);
    if (progressFill) progressFill.style.width = pct + '%';
    if (totalEl) totalEl.textContent = totalQty;
    if (maxEl) maxEl.textContent = max;
  }

  function updatePrice(stuks) {
    priceEl.classList.add('is-updating');
    setTimeout(() => {
      priceEl.querySelector('.kb-price-amount').textContent = stuks.price;
      priceEl.classList.remove('is-updating');
    }, 100);
  }

  // ── Section Rendering API: swap gallery when switching product
  const galleryCache = {};

  function switchGallery(productHandle) {
    if (!productHandle) return;

    const galleryEl = section.querySelector('.kb-gallery');
    if (!galleryEl) return;

    // Use cached HTML if available
    if (galleryCache[productHandle]) {
      galleryEl.outerHTML = galleryCache[productHandle];
      return;
    }

    const rootUrl = window.Shopify?.routes?.root || '/';
    const url = `${rootUrl}products/${productHandle}?section_id=${SID}`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGallery = doc.querySelector('.kb-gallery');
        if (newGallery) {
          galleryCache[productHandle] = newGallery.outerHTML;
          galleryEl.outerHTML = newGallery.outerHTML;
        }
      })
      .catch(err => console.error('Gallery section render failed:', err));
  }

  function switchStuks(newStuks, auto = false) {
    if (newStuks === activeStuks) return;
    activeStuks = newStuks;

    STUKS_CONFIG.forEach(s => {
      s.el.classList.toggle('kb-stuks-btn--active', s === newStuks);
      s.el.setAttribute('aria-checked', s === newStuks ? 'true' : 'false');
      if (s === newStuks && auto) {
        s.el.classList.add('kb-stuks-btn--auto-switched');
        s.el.addEventListener('animationend', () => {
          s.el.classList.remove('kb-stuks-btn--auto-switched');
        }, { once: true });
      }
    });

    switchGallery(newStuks.productHandle);
    updatePrice(newStuks);
    updateProgress();
    updatePlusButtons();
    updateCTA();
  }

  function updatePlusButtons() {
    const absoluteMax = STUKS_CONFIG[STUKS_CONFIG.length - 1].stuks;
    const atAbsoluteMax = totalQty >= absoluteMax;
    flavourRows.forEach(row => {
      const plusBtn = row.querySelector('.kb-qty-btn--plus');
      if (plusBtn) plusBtn.disabled = atAbsoluteMax;
    });
  }

  function updateCTA() {
    const max = getStuksMax();
    const ready = totalQty >= max;
    ctaBtn.disabled = !ready;

    if (totalQty === 0) {
      ctaHint.textContent = 'Selecteer de gewenste smaken om te beginnen';
    } else if (totalQty < max) {
      ctaHint.textContent = `Voeg nog ${max - totalQty} stuk${max - totalQty === 1 ? '' : 'ken'} toe`;
    } else {
      ctaHint.textContent = `Je trommel is klaar! 🎉`;
    }
  }

  function updateDrawerContent() {
    let html = '';
    let hasItems = false;
    flavourRows.forEach(row => {
      const qty  = parseInt(row.querySelector('.kb-qty-display').textContent, 10);
      const name = row.dataset.flavourName;
      if (qty > 0) {
        hasItems = true;
        html += `<div class="kb-drawer-item">
          <span class="kb-drawer-item__name">${name}</span>
          <span class="kb-drawer-item__qty">${qty}×</span>
        </div>`;
      }
    });

    if (!hasItems) {
      html = '<p class="kb-drawer__empty">Je trommel is nog leeg.</p>';
    }

    drawerBody.innerHTML = html;
    drawerTotal.textContent = activeStuks.price || '—';
  }

  // ── QTY interaction
  flavourRows.forEach(row => {
    const minusBtn  = row.querySelector('.kb-qty-btn--minus');
    const plusBtn   = row.querySelector('.kb-qty-btn--plus');
    const display   = row.querySelector('.kb-qty-display');

    function getQty() {
      return parseInt(display.textContent, 10);
    }

    function setQty(newQty) {
      newQty = Math.max(0, newQty);
      const old = getQty();
      const diff = newQty - old;

      // Check total cap
      const projectedTotal = totalQty + diff;
      if (projectedTotal < 0) return;

      // Auto-upgrade tier if needed before blocking
      if (projectedTotal > getStuksMax()) {
        const nextStuks = getStuksForQty(projectedTotal);
        if (nextStuks && nextStuks !== activeStuks) {
          switchStuks(nextStuks, true);
        } else {
          // Truly at the absolute max tier cap — shake and block
          plusBtn.style.animation = 'none';
          plusBtn.offsetHeight;
          plusBtn.style.animation = 'kb-shake 250ms ease';
          setTimeout(() => plusBtn.style.animation = '', 260);
          return;
        }
      }

      display.textContent = newQty;
      totalQty = projectedTotal;
      minusBtn.disabled = newQty === 0;
      row.classList.toggle('kb-flavour-row--has-qty', newQty > 0);

      // Auto-downgrade tier if total fits in a smaller tier
      if (diff < 0) {
        const bestStuks = getStuksForQty(Math.max(totalQty, 1));
        if (bestStuks && bestStuks !== activeStuks) {
          switchStuks(bestStuks, true);
        }
      }

      updateProgress();
      updatePlusButtons();
      updateCTA();
    }

    plusBtn.addEventListener('click', () => setQty(getQty() + 1));
    minusBtn.addEventListener('click', () => setQty(getQty() - 1));
  });

  // ── Manual stuks click
  STUKS_CONFIG.forEach(s => {
    s.el.addEventListener('click', () => {
      switchStuks(s, false);

      // If current totalQty exceeds new tier max, trim to max
      const max = s.stuks;
      if (totalQty > max) {
        // Reset all qtys proportionally (simplest: trim last rows)
        let remaining = max;
        flavourRows.forEach(row => {
          const display  = row.querySelector('.kb-qty-display');
          const minusBtn = row.querySelector('.kb-qty-btn--minus');
          const qty = parseInt(display.textContent, 10);
          if (remaining <= 0) {
            display.textContent = '0';
            row.classList.remove('kb-flavour-row--has-qty');
            minusBtn.disabled = true;
          } else if (qty > remaining) {
            display.textContent = remaining;
            remaining = 0;
          } else {
            remaining -= qty;
          }
        });
        totalQty = max;
        updateProgress();
        updatePlusButtons();
        updateCTA();
      }
    });
  });

  // ── Pre-selecteer stuks op basis van het bezochte product (vanuit collectie)
  const preselectStuks = parseInt(section.dataset.preselectStuks, 10);
  if (preselectStuks > 0) {
    const match = STUKS_CONFIG.find(s => s.stuks === preselectStuks);
    if (match && match !== activeStuks) switchStuks(match, false);
  }

  // ── Naamkaart selection (radio-style: click to select, click again to deselect)
  let selectedNaamkaart = null;
  const naamkaartCards = section.querySelectorAll('.kb-naamkaart-card');

  let priceSpan = section.querySelector('.kb-handschrift__price');
  const originalPriceText = priceSpan ? priceSpan.textContent : null;

  function showCardPrice(price) {
    if (!priceSpan) {
      const label = section.querySelector('.kb-handschrift__label');
      if (!label) return;
      priceSpan = document.createElement('span');
      priceSpan.className = 'kb-handschrift__price';
      label.appendChild(priceSpan);
    }
    priceSpan.textContent = ' (' + price + ')';
  }

  function restoreOriginalPrice() {
    if (originalPriceText !== null) {
      if (priceSpan) priceSpan.textContent = originalPriceText;
    } else {
      if (priceSpan) { priceSpan.remove(); priceSpan = null; }
    }
  }

  function positionAllTooltips() {
    naamkaartCards.forEach(card => {
      const tooltip = card.querySelector('.kb-naamkaart-tooltip');
      if (!tooltip) return;

      // Reset
      tooltip.style.left = '';
      tooltip.style.transform = '';
      tooltip.style.removeProperty('--tooltip-arrow-left');
      tooltip.style.removeProperty('--tooltip-arrow-transform');

      const cardRect = card.getBoundingClientRect();
      const tooltipWidth = tooltip.offsetWidth;
      const margin = 8;
      const vw = window.innerWidth;

      const defaultLeft = cardRect.left + cardRect.width / 2 - tooltipWidth / 2;
      const defaultRight = defaultLeft + tooltipWidth;
      let newLeftPx = null;

      if (defaultLeft < margin) {
        newLeftPx = margin - cardRect.left + tooltipWidth / 2;
      } else if (defaultRight > vw - margin) {
        newLeftPx = (vw - margin - tooltipWidth / 2) - cardRect.left;
      }

      if (newLeftPx !== null) {
        tooltip.style.left = newLeftPx + 'px';
        tooltip.style.transform = 'translateX(-50%)';
        const tooltipLeftInViewport = cardRect.left + newLeftPx - tooltipWidth / 2;
        const arrowLeft = (cardRect.left + cardRect.width / 2) - tooltipLeftInViewport;
        tooltip.style.setProperty('--tooltip-arrow-left', arrowLeft + 'px');
        tooltip.style.setProperty('--tooltip-arrow-transform', 'none');
      }
    });
  }

  positionAllTooltips();
  window.addEventListener('resize', positionAllTooltips);

  naamkaartCards.forEach(card => {
    card.addEventListener('click', () => {
      if (card.classList.contains('kb-naamkaart-card--active')) {
        // Deselect
        card.classList.remove('kb-naamkaart-card--active');
        selectedNaamkaart = null;
        restoreOriginalPrice();
        if (textarea) {
          textarea.disabled = true;
          textarea.value = '';
          if (charCount) charCount.textContent = `0 / ${textarea.maxLength} tekens`;
        }
      } else {
        // Deselect any previously selected
        naamkaartCards.forEach(c => c.classList.remove('kb-naamkaart-card--active'));
        // Select this one
        card.classList.add('kb-naamkaart-card--active');
        selectedNaamkaart = {
          variantId: card.dataset.variantId,
          productId: card.dataset.productId,
          name: card.dataset.name,
        };
        showCardPrice(card.dataset.price);
        if (textarea) {
          textarea.disabled = false;
          textarea.focus();
        }
      }
    });
  });

  // ── Drawer toggle (look for Bekijk trommel btn elsewhere on page, or wire inline)
  function openDrawer() {
    updateDrawerContent();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerClose.focus();
    document.body.style.overflow = 'hidden';
    drawerOpen = true;
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    drawerOpen = false;
  }

  if (drawerClose)    drawerClose.addEventListener('click', closeDrawer);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);

  drawer.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  const trommelId = new Date().getTime();
  // ── Add to cart
  ctaBtn.addEventListener('click', async () => {
    const items = [];

    // Add selected stuks product with flavours as properties
    if (activeStuks.variantId) {
      const parentProps = { '_trommel_id': trommelId };

      flavourRows.forEach(row => {
        const qty = parseInt(row.querySelector('.kb-qty-display').textContent, 10);
        if (qty > 0) {
          const name = row.dataset.flavourName;
          parentProps[name] = `${qty}x`;
        }
      });

      if (selectedNaamkaart) {
        parentProps['Naamkaartje'] = selectedNaamkaart.name;
        if (textarea && textarea.value.trim()) {
          parentProps['Bericht'] = textarea.value.trim();
        }
      }

      if (instructiesInput && instructiesInput.value.trim()) {
        const propName = instructiesInput.dataset.propertyName || 'Instructies';
        parentProps[propName] = instructiesInput.value.trim();
      }

      items.push({ id: activeStuks.variantId, quantity: 1, properties: parentProps });
    }

    // Add selected naamkaart
    if (selectedNaamkaart && selectedNaamkaart.variantId) {
      const naamkaartProps = { '_trommel_id': trommelId, '_is_naamkaartje': '1' };
      if (textarea && textarea.value.trim()) {
        naamkaartProps['Bericht'] = textarea.value.trim();
      }
      items.push({ id: parseInt(selectedNaamkaart.variantId, 10), quantity: 1, properties: naamkaartProps });
    }


    if (items.length === 0) return;

    ctaBtn.classList.add('is-loading');
    ctaBtn.disabled = true;

    try {
      const sectionsToRender = ['cart-drawer', 'cart-bubble'];
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items,
          sections: sectionsToRender.join(','),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('Cart add failed');
      const data = await response.json();

      // Replace cart drawer and cart bubble with freshly server-rendered HTML so
      // Zapiet (and any other cart UI) reflects the new cart state.
      const sectionTargets = [
        { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
      ];
      if (data.sections) {
        sectionTargets.forEach(({ id, section, selector }) => {
          const host = document.getElementById(id);
          if (!host || !data.sections[section]) return;
          const target = host.querySelector(selector) || host;
          const fresh = new DOMParser()
            .parseFromString(data.sections[section], 'text/html')
            .querySelector(selector);
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      }

      // Open the cart drawer (matches the theme's product form pattern).
      const cartDrawerEl = document.getElementById('Cart-Drawer');
      if (cartDrawerEl && typeof OverlayManager !== 'undefined') {
        OverlayManager.open(cartDrawerEl);
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      }

      // Re-initialize Zapiet Pickup + Delivery against the new DOM, AFTER the
      // drawer is visible so Zapiet can find its target elements. innerHTML does
      // not execute inline <script>s, so the page's own initializeZapietApp()
      // must be called manually after the swap.
      try {
        if (typeof window.initializeZapietApp === 'function') {
          window.initializeZapietApp();
        }
      } catch (zErr) {
        console.error('[koektrommel] initializeZapietApp() threw', zErr);
      }

      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { items: data.items || [] } }));

      // Success feedback
      ctaBtn.innerHTML = '<span class="kb-cta-btn__label">Toegevoegd! ✓</span>';
      setTimeout(() => {
        ctaBtn.innerHTML = '<span class="kb-cta-btn__label">Toevoegen in winkelwagen</span>';
        ctaBtn.disabled = false;
        ctaBtn.classList.remove('is-loading');
      }, 2500);

    } catch (err) {
      console.error('Koektrommel cart error:', err);
      ctaBtn.innerHTML = '<span class="kb-cta-btn__label">Fout — probeer opnieuw</span>';
      ctaBtn.classList.remove('is-loading');
      ctaBtn.disabled = false;
      setTimeout(() => {
        ctaBtn.innerHTML = '<span class="kb-cta-btn__label">Toevoegen in winkelwagen</span>';
        updateCTA();
      }, 2500);
    }
  });

  // ── Shake keyframe (injected once)
  if (!document.getElementById('kb-shake-keyframe')) {
    const style = document.createElement('style');
    style.id = 'kb-shake-keyframe';
    style.textContent = `
      @keyframes kb-shake {
        0%,100% { transform: translateX(0); }
        25%      { transform: translateX(-4px); }
        75%      { transform: translateX(4px); }
      }
    `;
    document.head.appendChild(style);
  }

  // ── Expose openDrawer globally so themes can wire "Bekijk trommel" buttons
  window[`KoektrommelBuilder_${SID}`] = { openDrawer, closeDrawer };

  // ── Init
  updateProgress();
  updateCTA();

})();